<template>
    <div>
        <div class="mainWrapper">
            <SuperAdminSideBar />

            <div class="rightContentWrapper">
                <div class="topNav">
                    <TopBarVue />
                </div>

                <div class="innerContainer">

                    <div class="theHeaderWrapper">
                        <div>Create talk</div>





                    </div>



                    <div v-if="props.type === 'text'">

                        <div class="textEditorBox">


                            <div class="textEditorHeader">
                                <div style="width: 50%">
                                    <b style="float: left">Text Editor</b>
                                </div>

                                <div class="editorBtns">


                                    <button type="button" @click="superAdminStore.openPromptInputModal" class="btn btn-dark"
                                        style="margin-right: 5px;"><b>Create With
                                            AI</b></button>

                                    <button @click="saveTalk" role="button" class="button-13"
                                        style="background-color: green; color: white;">Save
                                    </button>

                                </div>
                            </div>

                            <div class="titleBox">
                                <input v-model="superAdminStore.post.title" type="text" class="form-control titleInput"
                                    placeholder="Safety talk title..." />
                            </div>

                            <div class="contentInputBody">

                                <div class="textEditorWrapper">



                                    <div v-if="editor">

                                        <div class="btnBox">


                                            <div class="btnItem" @click="editor.chain().focus().toggleBold().run()"
                                                :disabled="!editor.can().chain().focus().toggleBold().run()"
                                                :class="{ 'btnItemSelected': editor.isActive('bold') }">

                                                <i class="bi bi-type-bold"></i>

                                            </div>

                                            <div class="btnItem" @click="editor.chain().focus().toggleItalic().run()"
                                                :disabled="!editor.can().chain().focus().toggleItalic().run()"
                                                :class="{ 'btnItemSelected': editor.isActive('italic') }">

                                                <i class="bi bi-type-italic"></i>

                                            </div>


                                            <div class="btnItem" @click="editor.chain().focus().toggleUnderline().run()"
                                                :class="{ 'btnItemSelected': editor.isActive('underline') }">

                                                <i class="bi bi-type-underline"></i>

                                            </div>

                                            <div class="btnItem" @click="editor.chain().focus().setParagraph().run()"
                                                :class="{ 'btnItemSelected': editor.isActive('paragraph') }">

                                                <i class="bi bi-paragraph"></i>

                                            </div>



                                            <div class="btnItem"
                                                @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
                                                :class="{ 'btnItemSelected': editor.isActive('heading', { level: 3 }) }">

                                                <i class="bi bi-type-h3"></i>

                                            </div>

                                            <div class="btnItem"
                                                @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
                                                :class="{ 'btnItemSelected': editor.isActive('heading', { level: 4 }) }">

                                                <i class="bi bi-type-h4"></i>

                                            </div>

                                            <div class="btnItem"
                                                @click="editor.chain().focus().toggleHeading({ level: 5 }).run()"
                                                :class="{ 'btnItemSelected': editor.isActive('heading', { level: 5 }) }">

                                                <i class="bi bi-type-h5"></i>

                                            </div>

                                            <div class="btnItem"
                                                @click="editor.chain().focus().toggleHeading({ level: 6 }).run()"
                                                :class="{ 'btnItemSelected': editor.isActive('heading', { level: 6 }) }">

                                                <i class="bi bi-type-h6"></i>

                                            </div>

                                            <div class="btnItem" @click="editor.chain().focus().setTextAlign('left').run()"
                                                :class="{ 'btnItemSelected': editor.isActive({ textAlign: 'left' }) }">

                                                <i class="bi bi-text-left"></i>

                                            </div>

                                            <div class="btnItem"
                                                @click="editor.chain().focus().setTextAlign('center').run()"
                                                :class="{ 'btnItemSelected': editor.isActive({ textAlign: 'center' }) }">

                                                <i class="bi bi-text-center"></i>

                                            </div>

                                            <div class="btnItem" @click="editor.chain().focus().setTextAlign('right').run()"
                                                :class="{ 'btnItemSelected': editor.isActive({ textAlign: 'right' }) }">

                                                <i class="bi bi-text-right"></i>

                                            </div>

                                            <div class="btnItem" @click="editor.chain().focus().toggleBulletList().run()"
                                                :class="{ 'btnItemSelected': editor.isActive('bulletList') }">

                                                <i class="bi bi-list-task" style="font-size: 20px;"></i>

                                            </div>

                                            <div class="btnItem" @click="editor.chain().focus().toggleOrderedList().run()"
                                                :class="{ 'is-active': editor.isActive('orderedList') }">
                                                <i class="bi bi-list-ol" style="font-size: 20px;"></i>
                                            </div>



                                            <div class="btnItem" @click="triggerFileInput">

                                                <i class="bi bi-card-image"></i>

                                                <input type="file" id="fileInput" hidden accept="image/*">




                                            </div>




                                        </div>

                                    </div>



                                    <EditorContent :editor="editor" />

                                </div>


                            </div>
                        </div>

                    </div>

                    <div v-if="props.type == 'video'">

                        <form @submit.prevent="superAdminStore.saveVideoTalk" style="max-width: 800px">

                            <input style="margin-bottom: 20px;" class="form-control" type="text" placeholder="Video Title"
                                id="videoTitle" v-model="superAdminStore.videoPost.title" required />

                            <div class="card">
                                <div class="card-header" style="background-color: #f7fff1">
                                    <div class="row">
                                        <div class="col-6">
                                            <h4 style="float: left">Video</h4>
                                        </div>

                                        <div class="col-6">
                                            <button class="btn btn-dark" style="float: right" type="button"
                                                @click="superAdminStore.openVideoEmbedModal">
                                                Embed
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-body" style="height: auto;">
                                    <div v-html="superAdminStore.videoPost.video_embed_code" class="video"></div>
                                </div>
                            </div>

                            <button class="btn btn-success mt-3" type="submit">
                                <b>Save</b>
                            </button>

                        </form>




                    </div>

                    <div v-if="props.type == 'pdf'">

                        pdf
                    </div>








                </div>
            </div>
        </div>




        <div v-if="superAdminStore.showVideoEmbedModal" class="modal-overlay">

            <div class="modal-box" style="width: 550px">

                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Embed Code</b>
                    </div>

                    <div>
                        <i @click="superAdminStore.closeVideoEmbedModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-content">


                    <textarea class="form-control" v-model="superAdminStore.videoPost.video_embed_code" cols="30" rows="10"
                        required></textarea>


                    <button class="btn btn-primary" style="margin-top: 10px;"
                        @click="superAdminStore.closeVideoEmbedModal">Add</button>


                </div>
            </div>
        </div>


        <div v-if="superAdminStore.showPromptInputModal" class="modal-overlay">

            <div class="modal-box" style="width: 550px">

                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Generate Talk</b>
                    </div>

                    <div>
                        <i @click="superAdminStore.closePromptInputModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-content" style="text-align: left;">


                    <form @submit.prevent="superAdminStore.generateTalk" class="theFormBox">

                        <div class="mb-4">
                            <label for="exampleInputEmail1" class="form-label"><b>Select Language</b></label>

                            <select v-model="superAdminStore.toolboxTalkFormData.language" class="form-select theInput"
                                aria-label="Default select example">


                                <option v-for="(language, index) in superAdminStore.languagesArray" :key="index"
                                    :value="language.name">{{ language.name }}</option>

                            </select>

                        </div>



                        <div class="mb-3">

                            <label for="exampleInputEmail1" class="form-label"><b>What kind of toolbox talk should be
                                    created?</b></label>

                            <textarea v-model="superAdminStore.toolboxTalkFormData.prompt" class="form-control theInput"
                                rows="4" cols="50" style="resize: none; height: 200px;"
                                placeholder="Example: Write a safety toolbox talk about ladder safety for a construction company that specializes in roofing."></textarea>
                        </div>




                        <div class="d-flex justify-content-center" v-if="superAdminStore.isLoading">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-dark theSubmitBtn" v-else><b>Generate Talk</b></button>

                    </form>







                </div>
            </div>
        </div>


        <div v-if="superAdminStore.showResultModal" class="modal-overlay">


            <div class="modal-box" style="width: 700px">

                <div class="model-box-header">

                    <button class="btn btn-success" style="font-size: 14px;" @click="superAdminStore.selectThisTalk">
                        <b>Use This</b>
                    </button>

                    <div>
                        <i @click="superAdminStore.closeTalkResultModal" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>



                <div class="modal-content" style="text-align: left; height: 600px; overflow-y: auto;">

                    <div class="resultsBox">



                        <div class="theTalkWrapper">

                            <div class="titleBox">


                                Title: {{ superAdminStore.theAIGenerateTalk.title }}

                            </div>

                            <div class="talkBody" ref="textToCopy">

                                <div v-html="superAdminStore.theAIGenerateTalk.body"></div>

                            </div>


                        </div>

                    </div>




                </div>


            </div>



        </div>




    </div>
</template>

<script setup>
// /* eslint-disable */
import SuperAdminSideBar from "@/components/SuperAdminSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { onMounted, defineProps, ref, watch } from 'vue';
import { useEditor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'
import Image from '@tiptap/extension-image'
import { useSuperAdminStore } from "@/stores/SuperAdminStore";
import SuperAdminService from "@/services/SuperAdminService";
import { toast } from "vue3-toastify";


const superAdminStore = useSuperAdminStore();

const props = defineProps({
    type: String
})


const editor = ref(
    useEditor({

        content: "",
        extensions: [
            StarterKit,
            Underline,
            TextAlign.configure({
                types: ['heading', 'paragraph'],
                defaultAlignment: 'left',
                alignments: ['left', 'center', 'right'],

            }),
            Image.configure({
                allowBase64: true,
            })
        ],
        // eslint-disable-next-line 
        onUpdate: ({ editor }) => {
            updateContent();
        }

    })
);


const saveTalk = () => {




    SuperAdminService.saveTalkToDB(superAdminStore.post)
        .then((response) => {


            toast("saved!", {
                position: "bottom-right",
                autoClose: 1000,
            });

            superAdminStore.post.title = ""
            superAdminStore.post.body = ""

              // ✅ Clear TipTap editor content
            if (editor.value) {
                editor.value.commands.clearContent();
            }


            // eslint-disable-next-line no-console
            console.log(response.data);
        })
        .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
        });



}


const updateContent = () => {

    superAdminStore.post.body = editor.value.getHTML();



    // console.log("UPDATED: ", campaignStore.postDetails.body)

};


watch(() => superAdminStore.post.body, (newVal) => {
    if (editor.value && newVal) {
        editor.value.commands.setContent(newVal);
    }
});

onMounted(() => {


    superAdminStore.post.content_type = props.type
    superAdminStore.videoPost.content_type = props.type


})







</script>

<style scoped> .mainWrapper {
     /* background-color: aliceblue; */
     display: flex;
     position: fixed;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
 }

 .rightContentWrapper {
     /* overflow-y: auto; */
     width: 83%;
     display: flex;
     flex-direction: column;
 }

 .contentContainer {
     /* overflow-y: auto; */
     background-color: rgb(208, 28, 55);
     /* margin: 30px; */
     margin-top: 100px;
 }

 .rightColumns {
     /* display: flex;
  flex-direction: column; */
 }

 .topNav {
     background-color: blue;
 }

 .innerContainer {
     /* margin-top: 200px; */
     /* background-color: blueviolet; */
     overflow-y: auto;
     padding-top: 30px;
     padding-left: 25px;
     padding-right: 25px;
     padding-bottom: 100px;
 }

 .theHeaderWrapper {
     display: flex;
     justify-content: space-between;
     text-align: left;
     font-size: 20px;
     font-weight: bold;
     margin-bottom: 20px;
     /* background-color: aqua; */
 }

 .searchBarWrapper {
     margin-top: 15px;
     width: 100%;
     padding-bottom: 20px;
     /* background-color: rgb(22, 166, 37); */
 }

 .theBar {
     width: 350px;
     box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
     border-radius: 10px;
 }


 .tableWrapper {
     margin-top: 20px;
     /* background-color: aqua; */
     width: 100%;
 }

 .my-custom-table tbody tr td {
     padding-top: 20px;
     /* Adjust the value as needed */
     padding-bottom: 20px;
     /* Adjust the value as needed */
 }

 .my-custom-table th {
     padding-bottom: 20px;
 }

 .my-custom-table th,
 .my-custom-table td {
     text-align: left;
     /* Aligns text to the left */
     padding-left: 20px;
     padding-right: 20px;
 }

 .campName {
     text-decoration: none;
     color: inherit;
 }

 .campName:hover {
     color: rgb(10, 159, 92);
     cursor: pointer;
     text-decoration: none;
 }

 .iconsRow {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
 }

 .theActionIcon {
     font-weight: bolder;
     font-size: 18px;
     color: rgb(5, 2, 2);
     cursor: pointer;
 }

 .theActionIcon:hover {
     cursor: pointer;
     color: rgb(30, 158, 30);
     scale: 1.3;
     transition: 1s;
 }

 .modal-overlay {
     position: fixed;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     background-color: rgba(0, 0, 0, 0.7);
     /* Semi-transparent black background */
     display: flex;
     justify-content: center;
     /* Center horizontally */
     align-items: center;
     /* Center vertically */
     z-index: 999;
     /* Ensure the modal is on top */
 }

 /* Styles for the modal box */
 .modal-box {
     background-color: white;
     width: 1100px;
     padding: 20px;
     border-radius: 2px;
     box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
 }

 .modal-content {
     text-align: center;
 }

 .model-box-header {
     display: flex;
     justify-content: space-between;
     /* background-color: antiquewhite; */
     height: 40px;
     margin-bottom: 15px;
 }

 .form-control {
     background-color: rgb(243, 246, 246);
 }

 .createBTN {
     width: 100%;
     margin-top: 20px;
 }

 .noTeamBox {
     display: flex;
     justify-content: center;
     align-items: center;
     height: 500px;
     width: 100%;
 }

 .noMatchBox {
     background-color: red;
     width: 100%;
 }

 .loadMoreBtn {
     background-color: black;
     border-radius: 10px;
     margin-top: 20px;
 }

 .button-13 {
     background-color: #fff;
     border: 1px solid #d5d9d9;
     border-radius: 8px;
     box-shadow: rgba(213, 217, 217, .5) 0 2px 5px 0;
     box-sizing: border-box;
     color: #0f1111;
     cursor: pointer;
     display: inline-block;
     font-family: "Amazon Ember", sans-serif;
     font-size: 13px;
     line-height: 29px;
     padding: 0 10px 0 11px;
     position: relative;
     text-align: center;
     text-decoration: none;
     user-select: none;
     -webkit-user-select: none;
     touch-action: manipulation;
     vertical-align: middle;
     width: 100px;
 }

 .button-13:hover {
     background-color: #f7fafa;
 }

 .button-13:focus {
     border-color: #008296;
     box-shadow: rgba(213, 217, 217, .5) 0 2px 5px 0;
     outline: 0;
 }


 .thePreviewContent {
     height: 600px;
     overflow-y: auto;

 }

 .button-6 {
     align-items: center;
     /* background-color: #FFFFFF; */
     background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
     border: 1px solid rgba(0, 0, 0, 0.1);
     border-radius: 0.25rem;
     box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
     box-sizing: border-box;
     color: rgba(0, 0, 0, 0.85);
     cursor: pointer;
     display: inline-flex;
     font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica,
         Arial, sans-serif;
     font-size: 16px;
     font-weight: 600;
     justify-content: center;
     line-height: 1.25;
     margin: 0;
     min-height: 3rem;
     padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
     position: relative;
     text-decoration: none;
     transition: all 250ms;
     user-select: none;
     -webkit-user-select: none;
     touch-action: manipulation;
     vertical-align: baseline;
     width: auto;
 }

 .button-6:hover,
 .button-6:focus {
     border-color: rgba(0, 0, 0, 0.15);
     box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
     color: rgba(0, 0, 0, 0.65);
 }

 .button-6:hover {
     transform: translateY(-1px);
 }

 .button-6:active {
     background-color: #f0f0f1;
     border-color: rgba(0, 0, 0, 0.15);
     box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
     color: rgba(0, 0, 0, 0.65);
     transform: translateY(0);
 }



 .textEditorBox {
     width: 850px;
     /* height: 700px; */
     box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
     border-radius: 10px;
 }

 .textEditorHeader {
     width: 100%;
     /* background-color: aliceblue; */
     padding: 10px;
     display: flex;
     flex-direction: row;
     justify-content: space-between;
 }


 .editorBtns {
     display: flex;
     justify-content: flex-end;
     /* background-color: rgb(205, 237, 237);  */
     width: 50%;
 }


 .titleBox {
     padding: 10px;
     width: 100%;
     /* background-color: #e3ffe7; */
 }


 .titleInput {
     border: 1px solid rgb(197, 197, 197);
 }

 .contentInputBody {
     text-align: left;
     margin: 10px;
     border: 1px solid rgb(197, 197, 197);
     border-radius: 5px;
     /* padding: 10px; */
     /* background-color: #d5d9d9; */
 }

 .aiBtn {
     margin-right: 10px;
     /* float: right; */
 }

 .textEditorWrapper {
     width: 100%;

     /* width: 100%; */
     /* background-color: red; */
 }


 .btnBox {
     display: flex;
     flex-direction: row;
     border: 2px solid rgb(79, 76, 76);
     width: 100%;
     /* background-color: purple; */
     height: 60px;
     padding: 4px;

 }


 .btnItem {
     display: flex;
     justify-content: center;
     align-items: center;
     background-color: white;
     width: 100%;
     margin: 4px;
     border-radius: 5px;

 }

 .btnItem:hover {
     display: flex;
     justify-content: center;
     align-items: center;
     background-color: rgb(236, 236, 234);
     width: 100%;
     margin: 4px;
     border-radius: 5px;
     cursor: pointer;

 }


 .btnItemSelected {
     display: flex;
     justify-content: center;
     align-items: center;
     background-color: rgb(236, 236, 234);
     width: 100%;
     margin: 4px;
     border-radius: 5px;
     cursor: pointer;

 }

 .mainWrapper ::v-deep .ProseMirror {
     /* Styles for the ProseMirror editor, which is inside the Tiptap EditorContent component */
     padding: 10px;
     border-bottom: 2px solid rgb(79, 76, 76);
     border-left: 2px solid rgb(79, 76, 76);
     border-right: 2px solid rgb(79, 76, 76);
     outline: none;
     min-height: 400px;
     text-align: left;
     max-height: 600px;
     overflow-y: auto;
 }



 .resultsBox {
     display: flex;
     justify-content: center;
     width: 100%;
     padding: 20px;
     /* background-color: rgb(137, 158, 177); */
 }

 .theTalkWrapper {
     display: flex;
     flex-direction: column;
     width: 800px;
     border-radius: 10px;
     box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
     padding: 20px;
     /* background-color: yellow; */
 }


 .titleBox {
     /* background-color: antiquewhite; */
     text-align: left;
     margin-bottom: 20px;
     font-size: 20px;
     font-weight: bold;
 }

 .talkBody {
     /* background-color: grey; */
     font-size: 17px;
     text-align: left;
 }


 .buttonOptionsWrapper {
     display: flex;
     justify-content: center;
     width: 100%;
     /* background-color: red; */
     margin-top: 15px;
     padding: 20px;
 }

 .theButtonBox {
     display: flex;
     justify-content: space-between;
     /* background-color: purple; */
     width: 800px;
 }
</style>